import React, { useState } from 'react';
import Search from 'src/assets/images/Search.svg';
import ModalClose from 'src/assets/images/ModalClose.svg';
import { getInventoryDetails } from '../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';

import {
    SearchBoxContainer,
    StyledInput,
    IconContainer,
    ClearIconContainer,
    SearchWarning,
} from './HighlightSearch.styled';

const HighlightSearch = ({ cursor, setSearchItem, setShowBtn }) => {
    const [showWarning, setShowWarning] = useState(false);
    const [ShowCloseIcon, setShowCloseIcon] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const accountId = useSelector(
        (state) =>
            state.consignmentReturnReducer.surgeryDetails.accountId.accountId
    );
    const { isShortTermConsignment } = useSelector(
        (state) => state.consignmentReducer.surgeryDetails
    );
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const searchHandler = (e) => {
        setInputValue(e.target.value);
        if (e.target.value.length < 3 && e.target.value != '') {
            setShowWarning(true);
        } else {
            setShowWarning(false);
            setShowBtn(true);
            setSearchItem(e.target.value);
            const payload = {
                accountNumber: accountId,
                productType: 'tissue',
                orderType: 'ZKA',
                resourceType: 'INVENTORY_LIST',
                sortCode: 'cfn',
                sortOrder: 'ASC',
                currentPage: '0',
                filterParam: 'all',
                searchQuery: e.target.value,
                pageSize: '50',
                isBKPProductsDisplay: isShortTermConsignment ? true : '',
            };
            dispatch(getInventoryDetails(payload));
        }
        if (e.target.value.length > 0) {
            setShowCloseIcon(true);
        } else {
            setShowCloseIcon(false);
        }
    };
    const clearSearch = () => {
        setShowCloseIcon(false);
        setInputValue('');
        setShowWarning(false);
        setSearchItem('');
        const payload = {
            accountNumber: accountId,
            productType: 'tissue',
            orderType: 'ZKA',
            resourceType: 'INVENTORY_LIST',
            sortCode: 'cfn',
            sortOrder: 'ASC',
            currentPage: '0',
            filterParam: 'all',
            searchQuery: '',
            pageSize: '50',
        };
        dispatch(getInventoryDetails(payload));
    };

    return (
        <>
            <SearchBoxContainer width={'382px'}>
                <IconContainer
                    width={'22px'}
                    height={'22px'}
                    mobileWidth={'22px'}
                    mobileHeight={'22px'}
                >
                    <img
                        src={Search}
                        alt={'Search Icon'}
                        width={'22px'}
                        height={'22px'}
                    />
                </IconContainer>
                <StyledInput
                    id="search"
                    type="text"
                    searchImg={Search}
                    value={inputValue}
                    placeholder={t(
                        'consignmentReturn.inventory.enterProductNoKeyword'
                    )}
                    onChange={(e) => searchHandler(e)}
                    autoComplete="off"
                />
                {ShowCloseIcon && (
                    <ClearIconContainer
                        id={`clear-search-${inputValue ? inputValue : 'empty'}`}
                        onClick={clearSearch}
                        cursor={cursor}
                    >
                        <img
                            src={ModalClose}
                            alt={'clearSearch'}
                            width="12px"
                            height="12px"
                        />
                    </ClearIconContainer>
                )}
            </SearchBoxContainer>
            <SearchWarning>
                {showWarning
                    ? t('consignmentReturn.inventory.enter3numbersToSeeResults')
                    : ''}
            </SearchWarning>
        </>
    );
};

export default HighlightSearch;
